<style>
  .mycontainer{
    height: 99vh
  }
</style>
<template>
  <v-container fluid ma-0 pa-0 class="mycontainer">
        <olmap :layersconfig="mapLayers"        />
   </v-container>
</template>

<script>
import {
  APP,
  DEV,
  getLog,
  VERSION,
  BUILD_DATE,
} from '../config';
import olmap from './olmap.vue';

const MODULE_NAME = APP;
const log = getLog(MODULE_NAME, 4, 2);

export default {
  name: APP,
  components: {
    olmap,
  },
  data: () => ({
    title: 'Périmètres',
    appName: APP,
    appTitle: `${APP} - ${VERSION}`,
    isInDev: DEV,
    mapLayers: {
      layerForQueryInit: 'pga_zones,rives_lac,amenagement_pga_ppa_msgroup,pga_foret_zone,bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,amenagement_rec_arch_note_msgroup,amenagement_jardins_histo',
      wmsLayers: [
        {
          layers: 'pga_zones,rives_lac,amenagement_pga_ppa_msgroup,pga_foret_zone,bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp',
          title: 'PGA-PPA',
          isVisible: true,
        },
        {
          layers: 'amenagement_jardins_histo',
          title: 'Jardins historiques',
          isVisible: false,
        },
        {
          layers: 'amenagement_rec_arch_note_msgroup,amenagement_rec_arch_mesure_msgroup',
          title: 'Recensement architectural et protection',
          isVisible: false,
        },
        {
          layers: 'amenagement_pga_limc',
          title: 'Limites des constructions',
          isVisible: false,
        },
      ],
    }, // FIN DE LA CONFIG DES mapLayers
  }),
  computed: {
  },
  mounted() {
    log.w(`mounted ${this.appTitle} build: ${BUILD_DATE}`);
  },
  methods: {},
};
</script>
